export default function PaymentSplit({ payments, setPayments }) {
    const methods = ["UPI", "CASH", "BANK", "CARD"];
  
    const updatePayment = (method, amount) => {
      setPayments({ ...payments, [method]: amount });
    };
  
    const total = methods.reduce((sum, m) => sum + (Number(payments[m]) || 0), 0);
  
    return (
      <div className="w-full z-[1]">
        <div className="rounded-2xl z-[1] border border-gray-200 bg-white/80 shadow-sm backdrop-blur-sm">
          {/* Header */}
          <div className="flex items-center justify-between border-b border-gray-100 px-4 py-3 sm:px-6">
            <h3 className="text-base font-semibold tracking-tight text-gray-900">
              Payment Split
            </h3>
            <span className="text-xs font-medium text-gray-500">
              Total: <span className="tabular-nums">₹{total.toFixed(2)}</span>
            </span>
          </div>
  
          {/* Methods */}
          <div className="divide-y divide-gray-100">
            {methods.map((m) => (
              <div key={m} className="px-4 py-3 sm:px-6">
                <div className="grid grid-cols-12 items-center gap-3">
                  {/* Label */}
                  <label
                    htmlFor={`amount-${m}`}
                    className="col-span-5 text-sm font-medium text-gray-700 sm:col-span-3 md:col-span-2"
                  >
                    {m}
                  </label>
  
                  {/* Input with ₹ adornment */}
                  <div className="col-span-7 sm:col-span-9 md:col-span-6">
                    <div className="relative">
                      <span className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-gray-500">
                        ₹
                      </span>
                      <input
                        id={`amount-${m}`}
                        type="number"
                        min="0"
                        inputMode="decimal"
                        className="w-full rounded-lg border border-gray-300 bg-white pl-8 pr-3 py-2 text-sm text-gray-900 shadow-sm outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100"
                        value={payments[m] ?? ""}
                        onChange={(e) => updatePayment(m, +e.target.value)}
                        placeholder="0.00"
                      />
                    </div>
                    <p className="mt-1 text-[11px] text-gray-500">
                      Enter {m} amount (optional).
                    </p>
                  </div>
  
                  {/* Visual meter (subtle, optional) */}
                  <div className="col-span-12 md:col-span-4">
                    <div className="h-2 w-full overflow-hidden rounded-full bg-gray-100">
                      <div
                        className="h-full bg-emerald-500 transition-all"
                        style={{
                          width:
                            total > 0
                              ? `${Math.min(
                                  100,
                                  ((Number(payments[m]) || 0) / total) * 100
                                ).toFixed(0)}%`
                              : "0%",
                        }}
                        aria-hidden="true"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
  
          {/* Footer note */}
          <div className="flex items-center justify-between px-4 py-3 text-xs text-gray-500 sm:px-6">
            <span>You can leave any method blank.</span>
            <span className="tabular-nums">Sum: ₹{total.toFixed(2)}</span>
          </div>
        </div>
      </div>
    );
  }
  